import { useQuery } from 'react-query'

import {
  DEFAULT_PO_BILL_TO_PRIMARY_CATEGORY,
  SystemPreferenceKeys,
  systemPreferenceQueryConfig,
} from '@webapp/platform/iam'

export const useQueryPOBillToPrimaryCategory = () => {
  const { data, isLoading, isError } = useQuery(
    systemPreferenceQueryConfig.getValue(
      SystemPreferenceKeys.PO_BILL_TO_LOCATION
    )
  )

  return {
    // Also the value shown while loading or after a failure; check `isError`
    // before treating it as the saved setting
    value: data?.value ?? DEFAULT_PO_BILL_TO_PRIMARY_CATEGORY,
    isLoading,
    isError,
  }
}
